import React from 'react';
import { ChevronIcon } from '@chegg-ui/theme';
import { useComponentTheme } from '@chegg-ui/theme';
import { CaretIcon } from '@chegg-ui/horizon-icons';
import { getThemeConfig } from '@chegg-ui/input';
import { FloatingInputWrapper } from '@chegg-ui/input-wrapper';
import { Listbox } from '@chegg-ui/listbox';
import { useDropdownBehavior } from '../shared';
import { FloatingFauxInputButton, PlaceholderOrValue } from '../styles';
var FloatingDropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var disabled = props.disabled,
      options = props.options,
      value = props.value,
      inputId = props.inputId,
      onSelectValue = props.onSelectValue,
      labelText = props.labelText,
      errorText = props.errorText,
      helperText = props.helperText,
      width = props.width,
      maxListboxHeight = props.maxListboxHeight,
      className = props.className,
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      listboxPortalContainer = props.listboxPortalContainer,
      dataTest = props['data-test'],
      theme = props.theme;

  var _useDropdownBehavior = useDropdownBehavior({
    ref: ref,
    value: value,
    options: options,
    disabled: disabled,
    onSelectValue: onSelectValue
  }),
      isDropdownOpen = _useDropdownBehavior.isDropdownOpen,
      onFauxInputClick = _useDropdownBehavior.onFauxInputClick,
      onFauxInputKeyDown = _useDropdownBehavior.onFauxInputKeyDown,
      fauxInputRef = _useDropdownBehavior.fauxInputRef,
      listBoxRef = _useDropdownBehavior.listBoxRef,
      onListboxBlur = _useDropdownBehavior.onListboxBlur,
      onListboxKeyDown = _useDropdownBehavior.onListboxKeyDown,
      pseudoFocusedListboxIndex = _useDropdownBehavior.pseudoFocusedListboxIndex,
      selectedListboxIndex = _useDropdownBehavior.selectedListboxIndex,
      displayedValue = _useDropdownBehavior.displayedValue,
      onSelectListboxOption = _useDropdownBehavior.onSelectListboxOption,
      isLabelHovered = _useDropdownBehavior.isLabelHovered;

  var componentTheme = useComponentTheme({
    name: 'Input',
    theme: getThemeConfig(theme)
  });
  var a11yErrorLabel = errorText ? "".concat(inputId, "_error") : '';
  return /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    inputId: inputId,
    labelText: labelText,
    errorText: errorText,
    helperText: helperText,
    width: width,
    disabled: disabled,
    trailingIcon: componentTheme.showCaretDownIcon ? isDropdownOpen ? /*#__PURE__*/React.createElement(CaretIcon, {
      pointing: "up"
    }) : /*#__PURE__*/React.createElement(CaretIcon, {
      pointing: "down"
    }) : /*#__PURE__*/React.createElement(ChevronIcon, {
      pointing: isDropdownOpen ? 'up' : 'down'
    }),
    adjustToBackgroundColor: adjustToBackgroundColor,
    className: className,
    "data-test": dataTest,
    isFloating: isDropdownOpen || Boolean(value)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FloatingFauxInputButton, {
    ref: fauxInputRef,
    id: inputId,
    role: "button",
    tabIndex: 0,
    disabled: disabled,
    "aria-haspopup": "listbox",
    "aria-expanded": isDropdownOpen || undefined,
    "aria-labelledby": "".concat(inputId, "_label ").concat(a11yErrorLabel),
    onMouseDown: onFauxInputClick,
    onKeyDown: onFauxInputKeyDown,
    hasTrailingIcon: true,
    adjustToBackgroundColor: adjustToBackgroundColor,
    "data-test": dataTest || inputId,
    isLabelHovered: isLabelHovered,
    errorText: errorText,
    customTheme: componentTheme
  }, /*#__PURE__*/React.createElement(PlaceholderOrValue, null, displayedValue)), /*#__PURE__*/React.createElement(Listbox, {
    ref: listBoxRef,
    inputId: inputId,
    options: options,
    isOpen: isDropdownOpen,
    pseudoFocusedIndex: pseudoFocusedListboxIndex,
    selectedIndex: selectedListboxIndex,
    onSelectOption: onSelectListboxOption,
    maxHeight: maxListboxHeight,
    onKeyDown: onListboxKeyDown,
    onBlur: onListboxBlur,
    tabIndex: -1,
    rendererRef: listboxPortalContainer ? fauxInputRef : undefined,
    container: listboxPortalContainer
  })));
});
FloatingDropdown.displayName = 'FloatingDropdown';
export default FloatingDropdown;